<script>
import router from '@/router'

export default {
  name: "ResetPassword",
  meta: {
    title: "비밀번호 재설정"
  },
  components: {

  },
  data() {
    return {
      form: {
        password: '',
        password2: '',
      },
      token: ''
    }
  },
  methods: {
    async onSubmit() {
      this.$log.debug('Check method onSubmit')
      if (!this.form.password || !this.form.password2) {
        this.$q.notify({ type: 'negative', message: '비밀번호를 입력해주세요.' })
        return
      }
      if (this.form.password !== this.form.password2) {
        this.$q.notify({ type: 'negative', message: '비밀번호가 일치하지 않습니다.' })
        return
      }

      let payload = {
        token: this.token,
        password: this.form.password
      }

      let config = {
        method : "POST",
        url : "/api/admin/reset-password",
        data : payload,
        name : "[ Axios / 비밀번호 재설정 실행 ]"
      }

      try {
        await this.$http(config)
          .then((res) => {
            if(res?.status === 200){
              this.$log.debug('[ Axios / 비밀번호 재설정 실행 ] 결과 = ', res)
  
              this.$q.notify({ type: 'positive', message: '비밀번호가 변경되었습니다.' })
              this.$router.push('/login')
            } else {
              throw new Error('Reset password failed')
            }
          })
          .catch((err) => {
            this.$q.notify({ type: 'negative', message: err.response?.data?.message || '오류가 발생했습니다.' })

          })
      } catch (err) {
        this.$log.debug('[ ResetPassword ] error = ', err)
      }
    }
  },
  mounted() {
    // URL에서 토큰 파싱
    const url = new URL(window.location.href);
    this.token = url.searchParams.get('token');
    if (!this.token) {
      this.$q.notify({ type: 'negative', message: '토큰 정보가 없습니다.' })

      router.push('/')
    }
  },
}
</script>

<template>
  <q-page id="site-container">
    <q-card style="min-width:360px">
      <q-card-section>
        <div class="text-h6">비밀번호 재설정</div>
      </q-card-section>
      <q-form>
        <q-card-section>
          <q-input
            v-model="form.password"
            type="password"
            label="새 비밀번호"
            :rules="[v => !!v || '비밀번호를 입력하세요']"
            autofocus
          />
          <q-input
            v-model="form.password2"
            type="password"
            label="새 비밀번호 확인"
            :rules="[v => v === form.password || '비밀번호가 일치하지 않습니다.']"
          />
        </q-card-section>
        <q-card-actions align="right">
          <q-btn 
            label="재설정" 
            color="primary" 
            @click="onSubmit" />
        </q-card-actions>
      </q-form>
    </q-card>
  </q-page>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
